<template>
	<a-modal width="55%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
		<a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
			<!--可编辑区域 start-->
			<div class="hidden">
				<a-form-item label="id" name="id">
					<a-input v-model:value="form.id" />
				</a-form-item>
			</div>
			<a-row :gutter="[24, 8]">
				<a-col :span="12">
					<a-form-item label="需求名称" name="name">
						<a-input v-model:value="form.name" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="需求类型" name="trType">
						<DictSelect v-model:value="form.trType" :dict-name="'demand_type'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="所属高新技术领域" name="highTechField">
						<DictSelect v-model:value="form.highTechField" :dict-name="'belong_techField'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<!-- <a-col :span="12">
					<a-form-item label="项目阶段" name="projectPhase">
						<DictSelect v-model:value="form.projectPhase" :dict-name="'projectStage'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="需求优先级" name="priority">
						<DictSelect v-model:value="form.priority" :dict-name="'demand_priority'" placeholder="请选择" />
					</a-form-item>
				</a-col> -->
				<a-col :span="12">
					<a-form-item label="研究经费(万元)" name="researchFunding">
						<a-inputNumber style="width: 100%" v-model:value="form.researchFunding" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="截止日期" name="deadline">
						<date-picker style="width: 100%" v-model:value="form.deadline" :format="dateFormat.DATE_DAY"
							:showTime="false" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="需求价值" name="demandValue">
						<DictSelect v-model:value="form.demandValue" :dict-name="'demand_value'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="需求对接人" name="dockingPerson">
						<a-input v-model:value="form.dockingPerson" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="联系电话" name="contactNumber">
						<a-input v-model:value="form.contactNumber" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item label="合作类型" name="typeCooperation">
						<DictSelect v-model:value="form.typeCooperation" :dict-name="'cooperation_methods'" placeholder="请选择" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="需求描述" name="description">
						<a-textarea :rows="4" v-model:value="form.description" placeholder="请输入" />
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item label="附件" name="file">
						<file-upload v-model:value="form.file" />
					</a-form-item>
				</a-col>
			</a-row>
		</a-form>
	</a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { technicalRequirementsInfo } from "@/api/achievementsService";
import DictSelect from "@/components/other/DictSelect";
import { dateFormat } from "@/config/variableConfig";

export default {
	name: "UserModal",
	components: { DictSelect },
	mixins: [formMixin],
	data() {
		return {
			dateFormat,
			companyData: [],
			form: {
				id: null,
			},
			rules: {
				researchFunding: [dataCheck.required({ type: 'number' })],
				typeCooperation: [dataCheck.required({})],
				deadline: [],
				description: [],
				file: [],
				demandValue: [],
				contactNumber: [dataCheck.required({}),dataCheck.mobile_phone],
				dockingPerson: [dataCheck.required({})],
				priority: [dataCheck.required({})],
				projectPhase: [dataCheck.required({})],
				highTechField: [dataCheck.required({})],
				trType: [dataCheck.required({})],
				name: [dataCheck.required({})],
				companyCode: [],
				id: []
			},
			submitUrl: technicalRequirementsInfo.saveOrUpdate
		}
	},
}
</script>
<style scoped lang="less"></style>
